import React from 'react';
import styled from 'styled-components';
import Title from '../../Components/Text/Title';
import Diagram from '../../Components/Item/Diagram';

import game_bg_img_top from '../../Images/game_bg_img_top.png';
import game_bg_img_bottom from '../../Images/game_bg_img_bottom.png';

import loadmap1 from '../../Images/loadmap1.png';
import loadmap2 from '../../Images/loadmap2.png';
import loadmap3 from '../../Images/loadmap3.png';
import loadmap_eng1 from '../../Images/loadmap_eng1.png';
import loadmap_eng2 from '../../Images/loadmap_eng2.png';
import loadmap_eng3 from '../../Images/loadmap_eng3.png';
import loadmap_m1 from '../../Images/loadmap_m1.png';
import loadmap_m2 from '../../Images/loadmap_m2.png';
import loadmap_m3 from '../../Images/loadmap_m3.png';
import loadmap_m_eng3 from '../../Images/loadmap_m_eng3.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 180px;
  padding-bottom: 280px;
  background-color: #110A3D;
`
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 1370px;
  position: relative;
  z-index: 10;
  justify-content: center;
  align-items: center;
  @media (max-width: 1410px) {
    width: 100%;
    padding: 0 20px;
  };
`
const TopBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  display: flex;
  justify-content: center;
  & > img {
    opacity: 0.3;
  }
`
const BottomBg = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  display: flex;
  justify-content: center;
  & > img {
    opacity: 0.3;
  }
`
const DiagramContainer = styled.div`
  width: 1370px;
  @media (max-width: 1410px) {
    width: 100%;
  };
`

const RoadmapContainer = ({ language }) => {
  return (
    <Container>
      <SubContainer>
        <Title
          text={'Roadmap'}
          color={'yellow'}
        />
        <DiagramContainer>
          <Diagram
            style={{ marginTop: 180 }}
            teblet={1070}
            tebletMaxWidth={470}
            img1={language === "Korean" ? loadmap1 : loadmap_eng1}
            img2={language === "Korean" ? loadmap2 : loadmap_eng2}
            img3={language === "Korean" ? loadmap3 : loadmap_eng3}
            tImg1={loadmap_m1}
            tImg2={loadmap_m2}
            tImg3={language === "Korean" ? loadmap_m3 : loadmap_m_eng3}
          />
        </DiagramContainer>
      </SubContainer>
      <TopBg>
        <img alt="" src={game_bg_img_top} />
      </TopBg>
      <BottomBg>
        <img alt="" src={game_bg_img_bottom} />
      </BottomBg>
    </Container>
  )
}

export default RoadmapContainer;